import PptxGenJS from 'pptxgenjs';
import { LAYOUT, COLORS, FONTS } from '../helpers/constants';
import { addConfidentialDisclaimer, contactSection } from '../template-parts';
import { PPTImageManager } from '../helpers/image-manager';
import { BASE_URL } from '@/config';

interface CoverData {
  projectTitle: string;
  id: string;
}

const WIDTH = LAYOUT.width;
const HEIGHT = LAYOUT.height;
const MARGIN = LAYOUT.margin;


export function coverSlide(pptx: PptxGenJS, data: CoverData, imageManager: PPTImageManager) {

  const slide = pptx.addSlide();
  const { projectTitle: title, id } = data;
  const opportunityURL = `${BASE_URL}/opportunities/${id}`;
  const logoWhite = imageManager.get('logo-white');

  // Background green
  slide.addShape(pptx.ShapeType.rect, {
    x: 0,
    y: 0,
    w: WIDTH,
    h: HEIGHT,
    fill: { color: COLORS.primary },
    line: { type: 'none' },
  });

  if (logoWhite) {
    slide.addImage({
      data: logoWhite,
      x: 3.75,
      y: 0.79,
      w: 3.23,
      h: 0.97,
    });
  }

  // Badge TEASER cover
  slide.addText('TEASER', {
    x: MARGIN,
    y: 3.42,
    w: 1.4,
    h: 0.35,
    shape: pptx.ShapeType.roundRect,
    fontFace: FONTS.title,
    fontSize: 16,
    bold: true,
    color: COLORS.white,
    align: 'center',
    valign: 'middle',
    fill: { color: COLORS.badgeGray },
    rectRadius: 0.5,
  });

  // Main title "Project"
  const projectTitle = title || 'Project XXXXXX';
  slide.addText(projectTitle, {
    x: MARGIN,
    y: 3.8,
    w: 5.63,
    h: 2.62,
    fontFace: FONTS.title,
    fontSize: 40,
    bold: true,
    color: COLORS.white,
    align: 'left',
    valign: 'top',
  });

  // Website, email and link to opportunity
  contactSection(slide, imageManager, opportunityURL);

  // Confidential disclaimer
  addConfidentialDisclaimer(slide);
}
